"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayTemplate = exports.TemplateType = exports.PREV_FIELD_32_CHARS_TEMPLATE = exports.NEXT_FIELD_32_CHARS_TEMPLATE = exports.LINK_FIELD_32_CHARS_TEMPLATE = exports.PREV_FIELD_17_CHARS_TEMPLATE = exports.NEXT_FIELD_17_CHARS_TEMPLATE = exports.LINK_FIELD_17_CHARS_TEMPLATE = exports.PREV_FIELD_10_CHARS_TEMPLATE = exports.NEXT_FIELD_10_CHARS_TEMPLATE = exports.LINK_FIELD_10_CHARS_TEMPLATE = exports.INVALID_DISPLAY_TEMPLATE_VALUES = exports.PREF_LINK_FIELD_NAME = exports.PREV_DISPLAY_FIELD_NAME = exports.PREF_DISPLAY_FIELD_NAME = exports.RND_DISPLAY_FIELD_NAME = exports.RECORD_TYPE_FIELD_NAME = exports.REF_COUNT_FIELD_NAME = exports.STREAMING_CHAINS_NAME_PATTERN = exports.QUANTITY_CHAIN_RECORDS_TO_REQUEST = exports.Event = void 0;
const state_1 = require("../../state");
const Add = 'Add';
const Update = 'Update';
const Remove = 'Remove';
const Complete = 'Complete';
exports.Event = Object.assign(Object.assign({}, state_1.StateEvent), { Complete, Add, Remove, Update });
exports.QUANTITY_CHAIN_RECORDS_TO_REQUEST = 10;
exports.STREAMING_CHAINS_NAME_PATTERN = /^(\d*?)#?\.([\w.]+)$/;
exports.REF_COUNT_FIELD_NAME = 'REF_COUNT';
exports.RECORD_TYPE_FIELD_NAME = 'RECORDTYPE';
exports.RND_DISPLAY_FIELD_NAME = 'RDNDISPLAY';
exports.PREF_DISPLAY_FIELD_NAME = 'PREF_DISP';
exports.PREV_DISPLAY_FIELD_NAME = 'PREV_DISP';
exports.PREF_LINK_FIELD_NAME = 'PREF_LINK';
exports.INVALID_DISPLAY_TEMPLATE_VALUES = ['@@@', 0];
exports.LINK_FIELD_10_CHARS_TEMPLATE = 'LINK_';
exports.NEXT_FIELD_10_CHARS_TEMPLATE = 'NEXT_LR';
exports.PREV_FIELD_10_CHARS_TEMPLATE = 'PREV_LR';
exports.LINK_FIELD_17_CHARS_TEMPLATE = 'LONGLINK';
exports.NEXT_FIELD_17_CHARS_TEMPLATE = 'LONGNEXTLR';
exports.PREV_FIELD_17_CHARS_TEMPLATE = 'LONGPREVLR';
exports.LINK_FIELD_32_CHARS_TEMPLATE = 'BR_LINK';
exports.NEXT_FIELD_32_CHARS_TEMPLATE = 'BR_NEXTLR';
exports.PREV_FIELD_32_CHARS_TEMPLATE = 'BR_PREVLR';
var TemplateType;
(function (TemplateType) {
    TemplateType["Chars10Template"] = "Chars10Template";
    TemplateType["Chars17Template"] = "Chars17Template";
    TemplateType["Chars32Template"] = "Chars32Template";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
exports.DisplayTemplate = {
    10: 0,
    11: 0,
    26: 12,
    27: 1,
    30: 1,
    31: 1,
    32: 0,
    33: 0,
    35: 1,
    37: 0,
    39: 1,
    40: 1,
    41: 0,
    45: 1,
    46: 0,
    47: 1,
    51: 0,
    53: 0,
    55: 0,
    57: 0,
    63: 0,
    74: 1,
    88: 0,
    89: 0,
    90: 8,
    91: 1,
    92: 13,
    93: 1,
    94: 1,
    95: 0,
    114: 2,
    134: 0,
    158: 2,
    159: 1,
    160: 1,
    161: 1,
    162: 3,
    163: 0,
    164: 0,
    165: 0,
    166: 1,
    167: 0,
    168: 0,
    173: 0,
    178: 0,
    179: 0,
    180: 1,
    181: 0,
    182: 0,
    183: 0,
    184: 0,
    185: 0,
    186: 4,
    187: 1,
    188: 0,
    189: 0,
    191: 1,
    193: 0,
    195: 0,
    197: 1,
    198: 1,
    199: 1,
    200: 2,
    201: 2,
    202: 0,
    203: 0,
    204: 0,
    205: 2,
    206: 0,
    207: 7,
    208: 0,
    209: 1,
    210: 0,
    211: 0,
    213: 1,
    214: 0,
    215: 2,
    216: 2,
    217: 1,
    218: 1,
    219: 0,
    220: 1,
    221: 0,
    222: 0,
    223: 0,
    224: 0,
    225: 0,
    226: 0,
    227: 0,
    228: 0,
    229: 1,
    230: 0,
    231: 1,
    232: 1,
    233: 3,
    234: 2,
    235: 1,
    238: 1,
    239: 0,
    240: 1,
    241: 1,
    242: 1,
    243: 0,
    244: 0,
    245: 0,
    246: 7,
    247: 7,
    248: 7,
    249: 3,
    250: 0,
    251: 0,
    252: 0,
    253: 0,
    254: 1,
    255: 0,
    1001: 0,
    1002: 0,
    1003: 0,
    1004: 0,
    1005: 0,
    1006: 0,
    1007: 0,
    1008: 0,
    1010: 1,
    1014: 1,
    1015: 1,
    1016: 1,
    1018: 1,
    1020: 0,
    1021: 8,
    1022: 2,
    1023: 1,
    1024: 1,
    1025: 1,
    1026: 7,
    1027: 4,
    1028: 3,
    1029: 3,
    1030: 5,
    1031: 5,
    1032: 2,
    1033: 3,
    1034: 3,
    1035: 2,
    1036: 7,
    1037: 15,
    1038: 15,
    1039: 15,
    1040: 14,
    1046: 2,
    1047: 1,
    1048: 1,
    1050: 3,
    1051: 3,
    1052: 2,
    1053: 1,
    1054: 7,
    1055: 3,
    1056: 3,
    1057: 3,
    1058: 16,
    1061: 0,
    1062: 0,
    1063: 0,
    1065: 0,
    1067: 2,
    1068: 2,
    1069: 0,
    1070: 0,
    1072: 0,
    1074: 0,
    1075: 0,
    1076: 2,
    1077: 1,
    1078: 1,
    1079: 5,
    1081: 0,
    1082: 0,
    1085: 0,
    1086: 0,
    1087: 0,
    1088: 0,
    1092: 0,
    1093: 0,
    1094: 1,
    1095: 12,
    1096: 8,
    1097: 0,
    1098: 6,
    1099: 6,
    1100: 6,
    1101: 0,
    1102: 0,
    1103: 1,
    1105: 12,
    1107: 0,
    1108: 2,
    1116: 2,
    1118: 0,
    1119: 1,
    1120: 1,
    1121: 1,
    1122: 2,
    1125: 0,
    1126: 3,
    1127: 1,
    1128: 2,
    1129: 4,
    1130: 15,
    1131: 2,
    1132: 1,
    1133: 1,
    1134: 1,
    1135: 5,
    1136: 4,
    1137: 3,
    1138: 2,
    1139: 4,
    1140: 3,
    1141: 3,
    1142: 4,
    1143: 4,
    1146: 0,
    1148: 0,
    1150: 0,
    1151: 2,
    1152: 2,
    1153: 2,
    1154: 2,
    1155: 2,
    1156: 2,
    1157: 3,
    1159: 1,
    1160: 3,
    1161: 3,
    1164: 1,
    1166: 0,
    1167: 0,
    1168: 8,
    1169: 15,
    1170: 4,
    1171: 2,
    1172: 0,
    1174: 2,
    1177: 0,
    1178: 0,
    1179: 0,
    1180: 0,
    1181: 0,
    1182: 0,
    1183: 0,
    1184: 0,
    1185: 0,
    1186: 0,
    1188: 0,
    1190: 1,
    1191: 3,
    1192: 2,
    1193: 0,
    1194: 0,
    1195: 0,
    1196: 1,
    1199: 0,
    1200: 1,
    1201: 1,
    1202: 2,
    1204: 0,
    1207: 0,
    1211: 2,
    1212: 1,
    1213: 1,
    1214: 0,
    1215: 0,
    1216: 2,
    1217: 3,
    1218: 1,
    1219: 1,
    1220: 1,
    1221: 15,
    1222: 3,
    1223: 4,
    1224: 2,
    1227: 0,
    1228: 0,
    1230: 3,
    1232: 4,
    1233: 0,
    1234: 0,
    1235: 0,
    1236: 1,
    1237: 1,
    1238: 2,
    1239: 2,
    1241: 0,
    1242: 16,
    1243: 0,
    1244: 0,
    1245: 0,
    1247: 1,
    1248: 2,
    1249: 2,
    1250: 0,
    1251: 2,
    1252: 2,
    1253: 2,
    1254: 2,
    1255: 0,
    1258: 0,
    1259: 0,
    1260: 0,
    1261: 6,
    1263: 1,
    1264: 1,
    1265: 3,
    1266: 7,
    1267: 15,
    1268: 15,
    1269: 10,
    1270: 1,
    1271: 14,
    1272: 5,
    1274: 0,
    1275: 0,
    1277: 4,
    1278: 4,
    1279: 4,
    1280: 4,
    1281: 0,
    1284: 15,
    1285: 0,
    1286: 5,
    1287: 3,
    1288: 4,
    1289: 0,
    1290: 0,
    1291: 0,
    1292: 5,
    1293: 5,
    1294: 7,
    1295: 7,
    1296: 0,
    1297: 0,
    1298: 3,
    1300: 0,
    1301: 0,
    1303: 0,
    1304: 0,
    1306: 0,
    1307: 0,
    1308: 7,
    1309: 0,
    1311: 1,
    1312: 0,
    1313: 0,
    1316: 0,
    1318: 0,
    1319: 1,
    1320: 0,
    1322: 0,
    1323: 0,
    1324: 0,
    1325: 0,
    1329: 0,
    1330: 2,
    1331: 3,
    1332: 1,
    1333: 3,
    1334: 0,
    1335: 0,
    1336: 0,
    1343: 2,
    1344: 1,
    1345: 1,
    1348: 0,
    1349: 2,
    1350: 1,
    1352: 1,
    1353: 10,
    1354: 10,
    1355: 0,
    1357: 1,
    1358: 2,
    1359: 0,
    1360: 0,
    1361: 0,
    1362: 0,
    1363: 12,
    1364: 9,
    1365: 9,
    1368: 2,
    1369: 1,
    1370: 2,
    1371: 2,
    1372: 2,
    1373: 2,
    1374: 2,
    1375: 2,
    1376: 2,
    1377: 2,
    1378: 2,
    1379: 2,
    1380: 2,
    1381: 0,
    1382: 1,
    1383: 0,
    1384: 4,
    1385: 5,
    1386: 1,
    1389: 0,
    1390: 1,
    1391: 1,
    1393: 0,
    1395: 0,
    1396: 0,
    1397: 0,
    1398: 0,
    1400: 0,
    1401: 0,
    1402: 0,
    1404: 0,
    1405: 0,
    1406: 2,
    1407: 0,
    1408: 2,
    1409: 0,
    1414: 0,
    1415: 15,
    1416: 15,
    1417: 2,
    1418: 0,
    1420: 1,
    1421: 0,
    1422: 0,
    1423: 0,
    1426: 3,
    1427: 0,
    1430: 0,
    1431: 2,
    1432: 2,
    1433: 2,
    1434: 2,
    1435: 2,
    1436: 2,
    1437: 2,
    1438: 2,
    1439: 2,
    1440: 2,
    1441: 2,
    1443: 2,
    1444: 4,
    1445: 4,
    1446: 2,
    1447: 2,
    1448: 0,
    1449: 1,
    1450: 1,
    1451: 1,
    1452: 1,
    1453: 0,
    1454: 0,
    1455: 15,
    1456: 1,
    1457: 3,
    1459: 1,
    1460: 6,
    1461: 10,
    1462: 2,
    1463: 0,
    1464: 2,
    1465: 7,
    1468: 1,
    1469: 2,
    1470: 0,
    1472: 0,
    1474: 0,
    1475: 0,
    1476: 0,
    1482: 0,
    1483: 1,
    1484: 4,
    1485: 4,
    1486: 0,
    1487: 0,
    1488: 1,
    1489: 0,
    1491: 2,
    1492: 1,
    1493: 1,
    1494: 1,
    1495: 0,
    1497: 0,
    1498: 3,
    1501: 4,
    1502: 1,
    1504: 1,
    1505: 1,
    1506: 1,
    1510: 8,
    1511: 0,
    1512: 7,
    1513: 0,
    1514: 0,
    1516: 9,
    1519: 0,
    1520: 0,
    1521: 0,
    1522: 10,
    1523: 0,
    1530: 1,
    1531: 3,
    1532: 0,
    1533: 0,
    1534: 0,
    1535: 0,
    1536: 1,
    1537: 1,
    1538: 1,
    1539: 2,
    1540: 1,
    1541: 2,
    1542: 2,
    1543: 2,
    1544: 14,
    1545: 0,
    1546: 10,
    1547: 6,
    1548: 8,
    1549: 10,
    1550: 1,
    1551: 1,
    1552: 2,
    1553: 2,
    1554: 0,
    1555: 1,
    1556: 1,
    1557: 2,
    1558: 2,
    1559: 3,
    1560: 3,
    1562: 3,
    1563: 0,
    1564: 1,
    1565: 0,
    1566: 1,
    1567: 2,
    1569: 1,
    1570: 2,
    1571: 0,
    1572: 1,
    1573: 1,
    1574: 1,
    1575: 1,
    1576: 1,
    1577: 0,
    1578: 2,
    1579: 7,
    1580: 2,
    1581: 2,
    1583: 0,
    1586: 0,
    1587: 0,
    1590: 10,
    1591: 10,
    1593: 0,
    1594: 0,
    1595: 0,
    1596: 0,
    1597: 0,
    1598: 1,
    1599: 0,
    1604: 1,
    1605: 0,
    1606: 0,
    1608: 1,
    1609: 1,
    1610: 1,
    1611: 6,
    1612: 0,
    1613: 1,
    1614: 1,
    1615: 16,
    1617: 2,
    1619: 0,
    1622: 0,
    1623: 1,
    1624: 0,
    1625: 1,
    1627: 0,
    1628: 1,
    1629: 2,
    1630: 7,
    1632: 1,
    1633: 1,
    1634: 1,
    1635: 4,
    1636: 0,
    1637: 0,
    1644: 0,
    1645: 0,
    1647: 0,
    1650: 2,
    1652: 2,
    1654: 2,
    1655: 2,
    1656: 5,
    1657: 14,
    1658: 5,
    1659: 14,
    1660: 9,
    1661: 8,
    1662: 0,
    1663: 0,
    1664: 0,
    1665: 0,
    1666: 0,
    1668: 0,
    1669: 4,
    1670: 2,
    1671: 2,
    1672: 4,
    1673: 4,
    1675: 2,
    1676: 2,
    1677: 2,
    1678: 2,
    1679: 1,
    1680: 1,
    1683: 1,
    1684: 3,
    1685: 7,
    1687: 1,
    1688: 1,
    1689: 2,
    1690: 0,
    1691: 1,
    1692: 0,
    1693: 2,
    1694: 2,
    1695: 2,
    1699: 2,
    1701: 0,
    1702: 0,
    1703: 0,
    1704: 0,
    1705: 0,
    1706: 0,
    1707: 0,
    1715: 0,
    1716: 0,
    1718: 0,
    1719: 0,
    1720: 0,
    1722: 0,
    1723: 3,
    1724: 3,
    1727: 0,
    1728: 1,
    1729: 1,
    1730: 0,
    1731: 0,
    1738: 0,
    1741: 1,
    1742: 1,
    1744: 17,
    1745: 2,
    1746: 4,
    1747: 4,
    1748: 1,
    1749: 1,
    1750: 1,
    1751: 6,
    1752: 0,
    1756: 1,
    1758: 1,
    1760: 0,
    1761: 0,
    1762: 0,
    1763: 1,
    1764: 0,
    1765: 0,
    1767: 1,
    1768: 0,
    1769: 1,
    1770: 0,
    1771: 0,
    1772: 0,
    1773: 0,
    1774: 15,
    1775: 1,
    1778: 2,
    1779: 1,
    1780: 0,
    1781: 0,
    1784: 3,
    1785: 2,
    1786: 3,
    1790: 2,
    1792: 6,
    1799: 1,
    1800: 0,
    1801: 0,
    1802: 2,
    1804: 0,
    1805: 0,
    1806: 0,
    1807: 0,
    1808: 0,
    1809: 0,
    1810: 0,
    1811: 0,
    1812: 0,
    1813: 0,
    1814: 0,
    1815: 0,
    1816: 0,
    1817: 0,
    1818: 0,
    1821: 1,
    1822: 1,
    1823: 2,
    1824: 10,
    1825: 9,
    1826: 0,
    1827: 0,
    1828: 0,
    1829: 2,
    1830: 1,
    1831: 0,
    1833: 0,
    1834: 8,
    1835: 2,
    1840: 3,
    1843: 0,
    1846: 0,
    1847: 7,
    1848: 7,
    1849: 7,
    1850: 7,
    1851: 7,
    1854: 1,
    1855: 1,
    1856: 1,
    1859: 1,
    1861: 1,
    1863: 0,
    1864: 1,
    1867: 0,
    1869: 0,
    1870: 0,
    1871: 0,
    1872: 0,
    1873: 0,
    1874: 0,
    1875: 0,
    1876: 8,
    1878: 1,
    1880: 2,
    1884: 8,
    1885: 9,
    1886: 9,
    1890: 0,
    1893: 12,
    1895: 7,
    1896: 15,
    1897: 6,
    1898: 5,
    1900: 2,
    1901: 1,
    1902: 1,
    1903: 1,
    1904: 1,
    1906: 0,
    1910: 2,
    1911: 5,
    1912: 5,
    1913: 5,
    1916: 0,
    1917: 6,
    1920: 0,
    1922: 2,
    1924: 0,
    1927: 2,
    1928: 2,
    1929: 2,
    1935: 0,
    1936: 1,
    1937: 0,
    1938: 0,
    1939: 0,
    1940: 0,
    1941: 0,
    1942: 0,
    1943: 0,
    1945: 0,
    1946: 1,
    1947: 1,
    1948: 5,
    1951: 2,
    1952: 3,
    1953: 0,
    1957: 0,
    1958: 0,
    1960: 6,
    1961: 1,
    1962: 17,
    1966: 0,
    1967: 0,
    1968: 0,
    1969: 0,
    1971: 0,
    1973: 0,
    1974: 1,
    1975: 5,
    1979: 0,
    1980: 0,
    1981: 0,
    1982: 0,
    1984: 0,
    1985: 0,
    1986: 0,
    1987: 0,
    1988: 0,
    1989: 0,
    1990: 0,
    1991: 0,
    1992: 6,
    1993: 5,
    1994: 0,
    1995: 6,
    1997: 0,
    1998: 1,
    2000: 0,
    2003: 1,
    2005: 0,
    2007: 1,
    2008: 0,
    2011: 2,
    2012: 1,
    2014: 9,
    2015: 6,
    2016: 0,
    2017: 0,
    2019: 4,
    2020: 0,
    2021: 1,
    2022: 11,
    2023: 0,
    2024: 1,
    2025: 1,
    2026: 9,
    2027: 10,
    2028: 10,
    2029: 17,
    2030: 1,
    2032: 1,
    2033: 2,
    2036: 1,
    2037: 0,
    2038: 1,
    2040: 0,
    2041: 1,
    2043: 0,
    2044: 0,
    2046: 2,
    2050: 1,
    2051: 0,
    2052: 6,
    2053: 8,
    2054: 10,
    2055: 6,
    2056: 8,
    2057: 10,
    2058: 1,
    2059: 1,
    2064: 2,
    2068: 0,
    2069: 0,
    2082: 0,
    2083: 1,
    2084: 6,
    2086: 1,
    2088: 0,
    2089: 0,
    2093: 1,
    2094: 0,
    2095: 0,
    2098: 0,
    2099: 0,
    2151: 0,
    2154: 1,
    2158: 1,
    2159: 0,
    2160: 0,
    2161: 0,
    2162: 0,
    2163: 1,
    2164: 8,
    2166: 0,
    2168: 0,
    2169: 5,
    2172: 6,
    2175: 0,
    2178: 0,
    2179: 1,
    2181: 0,
    2188: 0,
    2192: 3,
    2193: 0,
    2199: 6,
    2202: 0,
    2203: 0,
    2204: 0,
    2205: 0,
    2206: 0,
    2207: 0,
    2208: 0,
    2209: 0,
    2210: 1,
    2211: 1,
    2213: 6,
    2214: 4,
    2216: 1,
    2217: 3,
    2227: 0,
    2228: 0,
    2232: 0,
    2233: 0,
    2234: 0,
    2237: 1,
    2238: 3,
    2239: 2,
    2245: 0,
    2247: 0,
    2250: 2,
    2252: 1,
    2255: 0,
    2256: 0,
    2259: 0,
    2260: 0,
    2261: 0,
    2262: 0,
    2263: 0,
    2268: 3,
    2269: 3,
    2270: 1,
    2275: 0,
    2278: 0,
    2279: 2,
    2280: 2,
    2281: 10,
    2282: 1,
    2283: 0,
    2286: 0,
    2288: 1,
    2289: 1,
    2291: 0,
    2292: 0,
    2293: 0,
    2298: 0,
    2299: 0,
    2301: 1,
    2302: 0,
    2303: 0,
    2304: 0,
    2306: 0,
    2307: 0,
    2308: 0,
    2309: 0,
    2310: 3,
    2313: 1,
    2314: 1,
    2316: 0,
    2317: 1,
    2321: 1,
    2322: 1,
    2323: 1,
    2324: 1,
    2326: 3,
    2328: 0,
    2331: 6,
    2343: 0,
    2353: 1,
    2354: 1,
    2355: 0,
    2357: 0,
    2363: 1,
    2366: 1,
    2367: 3,
    2369: 2,
    2371: 2,
    2372: 1,
    2373: 0,
    2375: 0,
    2376: 6,
    2377: 6,
    2378: 0,
    2379: 0,
    2381: 0,
    2383: 0,
    2385: 0,
    2387: 0,
    2388: 0,
    2390: 1,
    2391: 0,
    2395: 0,
    2396: 0,
    2397: 1,
    2398: 0,
    2399: 0,
    2400: 0,
    2401: 0,
    2403: 0,
    2405: 2,
    2406: 2,
    2408: 2,
    2409: 2,
    2413: 0,
    2415: 1,
    2416: 1,
    2425: 6,
    2426: 6,
    2427: 6,
    2428: 6,
    2429: 0,
    2430: 1,
    2431: 1,
    2432: 0,
    2433: 1,
    2434: 2,
    2435: 0,
    2436: 0,
    2440: 2,
    2443: 0,
    2447: 0,
    2451: 3,
    2452: 3,
    2453: 7,
    2456: 0,
    2464: 0,
    2465: 0,
    2466: 0,
    2469: 0,
    2470: 2,
    2471: 2,
    2473: 2,
    2474: 2,
    2475: 0,
    2478: 0,
    2481: 3,
    2482: 3,
    2487: 3,
    2488: 3,
    2490: 0,
    2495: 0,
    2497: 3,
    2498: 0,
    2500: 0,
    2502: 2,
    2503: 2,
    2505: 2,
    2508: 2,
    2509: 0,
    2511: 0,
    2512: 1,
    2513: 1,
    2514: 1,
    2516: 0,
    2517: 1,
    2520: 0,
    2522: 0,
    2524: 1,
    2528: 0,
    2533: 0,
    2535: 0,
    2537: 3,
    2538: 2,
    2542: 3,
    2543: 1,
    2545: 0,
    2546: 0,
    2547: 1,
    2548: 1,
    2550: 3,
    2555: 3,
    2560: 2,
    2562: 3,
    2563: 0,
    2564: 0,
    2565: 0,
    2566: 0,
    2568: 3,
    2569: 3,
    2570: 3,
    2573: 2,
    2574: 2,
    2576: 2,
    2577: 2,
    2578: 1,
    2581: 0,
    2583: 0,
    2584: 0,
    2585: 0,
    2587: 0,
    2588: 0,
    2589: 0,
    2590: 0,
    2591: 0,
    2593: 0,
    2594: 0,
    2595: 0,
    2597: 2,
    2598: 0,
    2599: 0,
    2653: 1,
    2655: 1,
    2656: 0,
    2658: 1,
    2662: 0,
    2663: 0,
    2664: 0,
    2668: 1,
    2670: 1,
    2672: 0,
    2674: 1,
    2677: 1,
    2679: 1,
    2680: 1,
    2682: 3,
    2683: 3,
    2684: 3,
    2685: 3,
    2691: 1,
    2693: 1,
    2694: 1,
    2695: 1,
    2702: 0,
    2703: 9,
    2704: 0,
    2705: 0,
    2707: 1,
    2708: 1,
    2709: 1,
    2710: 1,
    2711: 0,
    2714: 0,
    2717: 0,
    2718: 2,
    2719: 2,
    2720: 2,
    2721: 2,
    2722: 2,
    2723: 2,
    2724: 0,
    2725: 1,
    2727: 2,
    2728: 2,
    2733: 0,
    2738: 0,
    2739: 0,
    2742: 0,
    2744: 3,
    2745: 3,
    2746: 0,
    2748: 0,
    2750: 0,
    2751: 0,
    2754: 3,
    2755: 15,
    2756: 0,
    2757: 0,
    2758: 0,
    2759: 3,
    2761: 1,
    2763: 0,
    2764: 0,
    2774: 0,
    2781: 0,
    2786: 0,
    2789: 15,
    2791: 0,
    2792: 0,
    2796: 2,
    2799: 1,
    2800: 1,
    2801: 3,
    2802: 3,
    2813: 2,
    2814: 1,
    2815: 1,
    2816: 0,
    2820: 0,
    2822: 0,
    2825: 0,
    2830: 0,
    2831: 0,
    2832: 0,
    2833: 0,
    2834: 1,
    2835: 0,
    2836: 0,
    2837: 0,
    2838: 3,
    2842: 1,
    2846: 3,
    2847: 1,
    2848: 0,
    2849: 0,
    2850: 2,
    2851: 0,
    2852: 2,
    2853: 0,
    2854: 3,
    2855: 0,
    2858: 1,
    2859: 6,
    2860: 6,
    2861: 3,
    2863: 0,
    2865: 0,
    2867: 5,
    2869: 1,
    2877: 0,
    2882: 1,
    2883: 1,
    2884: 1,
    2885: 1,
    2886: 1,
    2887: 1,
    2888: 1,
    2889: 1,
    2890: 1,
    2891: 1,
    2892: 1,
    2893: 1,
    2897: 1,
    2898: 1,
    2899: 1,
    2900: 1,
    2901: 1,
    2902: 1,
    2903: 1,
    2904: 1,
    2905: 1,
    2906: 1,
    2907: 1,
    2908: 1,
    2910: 0,
    2911: 0,
    2913: 3,
    2914: 3,
    2916: 2,
    2917: 0,
    2918: 1,
    2919: 0,
    2920: 1,
    2932: 0,
    2933: 0,
    2935: 0,
    2938: 0,
    2939: 2,
    2940: 0,
    2942: 0,
    2944: 0,
    2945: 0,
    2946: 2,
    2948: 3,
    2949: 1,
    2951: 1,
    2954: 0,
    2955: 10,
    2956: 1,
    2959: 1,
    2960: 6,
    2961: 6,
    2963: 1,
    2964: 0,
    2965: 3,
    2968: 0,
    2970: 0,
    2971: 2,
    2972: 2,
    2973: 2,
    2974: 2,
    2975: 2,
    2976: 2,
    2980: 2,
    2981: 1,
    2982: 3,
    2983: 16,
    2984: 2,
    2986: 1,
    2988: 1,
    2991: 0,
    2992: 0,
    2993: 3,
    2994: 0,
    2995: 0,
    2996: 0,
    2997: 0,
    3004: 0,
    3007: 0,
    3011: 2,
    3012: 0,
    3015: 0,
    3019: 0,
    3020: 1,
    3021: 0,
    3022: 0,
    3027: 0,
    3028: 2,
    3030: 0,
    3031: 1,
    3032: 0,
    3033: 0,
    3034: 0,
    3035: 0,
    3036: 0,
    3038: 1,
    3039: 2,
    3041: 0,
    3042: 0,
    3044: 2,
    3045: 2,
    3047: 1,
    3048: 0,
    3050: 0,
    3052: 2,
    3055: 0,
    3057: 2,
    3059: 2,
    3061: 3,
    3062: 3,
    3063: 2,
    3065: 3,
    3066: 3,
    3068: 3,
    3071: 2,
    3073: 2,
    3074: 4,
    3076: 3,
    3077: 0,
    3081: 3,
    3083: 2,
    3085: 2,
    3090: 1,
    3092: 0,
    3093: 2,
    3094: 2,
    3095: 2,
    3096: 2,
    3097: 2,
    3098: 2,
    3099: 2,
    3100: 2,
    3101: 2,
    3105: 0,
    3106: 0,
    3107: 1,
    3108: 1,
    3109: 2,
    3110: 1,
    3112: 11,
    3114: 0,
    3117: 0,
    3118: 6,
    3120: 2,
    3121: 1,
    3122: 0,
    3125: 1,
    3126: 0,
    3127: 2,
    3129: 1,
    3133: 0,
    3136: 0,
    3137: 0,
    3138: 2,
    3139: 2,
    3140: 2,
    3141: 2,
    3145: 0,
    3146: 0,
    3148: 0,
    3149: 0,
    3150: 1,
    3151: 0,
    3152: 0,
    3153: 0,
    3154: 0,
    3155: 0,
    3156: 0,
    3157: 0,
    3158: 0,
    3159: 0,
    3160: 0,
    3161: 0,
    3162: 2,
    3163: 2,
    3164: 2,
    3165: 2,
    3166: 2,
    3167: 2,
    3169: 1,
    3171: 2,
    3175: 1,
    3176: 0,
    3177: 0,
    3178: 0,
    3179: 0,
    3202: 0,
    3203: 1,
    3204: 1,
    3210: 0,
    3211: 0,
    3212: 0,
    3215: 0,
    3216: 0,
    3217: 0,
    3218: 0,
    3221: 0,
    3222: 0,
    3223: 0,
    3224: 0,
    3225: 0,
    3226: 0,
    3227: 0,
    3229: 0,
    3230: 0,
    3231: 0,
    3232: 8,
    3233: 2,
    3235: 1,
    3236: 1,
    3237: 0,
    3239: 0,
    3241: 0,
    3244: 0,
    3245: 0,
    3247: 0,
    3249: 1,
    3251: 0,
    3254: 0,
    3256: 0,
    3257: 0,
    3259: 0,
    3260: 0,
    3261: 0,
    3262: 1,
    3264: 4,
    3265: 6,
    3267: 1,
    3268: 0,
    3269: 0,
    3271: 2,
    3272: 0,
    3274: 0,
    3275: 1,
    3277: 2,
    3278: 2,
    3281: 3,
    3283: 4,
    3284: 3,
    3287: 3,
    3288: 3,
    3289: 4,
    3290: 7,
    3292: 2,
    3295: 0,
    3296: 0,
    3299: 1,
    3300: 3,
    3303: 0,
    3305: 0,
    3306: 2,
    3308: 1,
    3309: 0,
    3310: 0,
    3313: 0,
    3314: 0,
    3315: 0,
    3316: 3,
    3317: 2,
    3318: 3,
    3319: 13,
    3321: 0,
    3323: 0,
    3324: 0,
    3326: 1,
    3328: 3,
    3329: 3,
    3331: 3,
    3333: 2,
    3334: 0,
    3335: 0,
    3336: 0,
    3337: 0,
    3338: 0,
    3339: 0,
    3340: 0,
    3341: 0,
    3342: 0,
    3343: 0,
    3344: 0,
    3345: 0,
    3346: 0,
    3348: 0,
    3349: 0,
    3350: 0,
    3352: 2,
    3354: 1,
    3355: 1,
    3365: 2,
    3372: 1,
    3373: 0,
    3374: 0,
    3377: 3,
    3378: 3,
    3380: 5,
    3381: 0,
    3382: 2,
    3385: 0,
    3388: 1,
    3390: 0,
    3392: 0,
    3393: 0,
    3394: 2,
    3395: 2,
    3397: 0,
    3399: 0,
    3400: 1,
    3402: 0,
    3406: 3,
    3410: 0,
    3411: 8,
    3412: 0,
    3413: 17,
    3416: 1,
    3417: 0,
    3418: 1,
    3420: 2,
    3422: 1,
    3425: 3,
    3427: 2,
    3428: 2,
    3429: 0,
    3430: 1,
    3441: 0,
    3442: 0,
    3443: 0,
    3444: 0,
    3445: 1,
    3451: 1,
    3452: 1,
    3453: 2,
    3454: 8,
    3455: 7,
    3456: 1,
    3460: 2,
    3463: 1,
    3464: 0,
    3465: 2,
    3467: 7,
    3469: 11,
    3471: 2,
    3475: 0,
    3478: 3,
    3482: 0,
    3484: 1,
    3486: 0,
    3487: 0,
    3489: 13,
    3492: 0,
    3494: 0,
    3496: 0,
    3497: 2,
    3498: 0,
    3500: 1,
    3503: 0,
    3507: 1,
    3508: 1,
    3512: 2,
    3516: 2,
    3517: 2,
    3520: 1,
    3524: 0,
    3530: 1,
    3532: 4,
    3535: 0,
    3536: 0,
    3539: 0,
    3542: 10,
    3544: 0,
    3546: 3,
    3547: 0,
    3548: 3,
    3549: 3,
    3550: 3,
    3551: 2,
    3552: 2,
    3553: 4,
    3554: 4,
    3555: 3,
    3558: 2,
    3559: 2,
    3563: 0,
    3564: 0,
    3566: 0,
    3577: 0,
    3579: 0,
    3580: 0,
    3585: 0,
    3586: 3,
    3587: 0,
    3588: 1,
    3593: 0,
    3594: 0,
    3595: 14,
    3597: 2,
    3598: 2,
    3599: 2,
    3602: 3,
    3604: 2,
    3607: 0,
    3608: 1,
    3609: 6,
    3611: 0,
    3612: 0,
    3614: 3,
    3615: 0,
    3616: 0,
    3618: 2,
    3619: 0,
    3624: 0,
    3625: 0,
    3626: 1,
    3627: 0,
    3628: 0,
    3629: 3,
    3630: 3,
    3631: 3,
    3632: 1,
    3633: 3,
    3634: 1,
    3636: 0,
    3637: 2,
    3644: 0,
    3646: 3,
    3647: 1,
    3648: 2,
    3649: 0,
    3650: 2,
    3652: 0,
    3653: 3,
    3660: 1,
    3663: 2,
    3664: 2,
    3665: 0,
    3669: 1,
    3674: 0,
    3676: 0,
    3680: 0,
    3681: 0,
    3684: 1,
    3686: 0,
    3688: 0,
    3695: 0,
    3696: 1,
    3697: 0,
    3703: 0,
    3704: 2,
    3707: 0,
    3708: 1,
    3714: 3,
    3720: 1,
    3721: 7,
    3722: 1,
    3723: 0,
    3724: 0,
    3725: 0,
    3730: 2,
    3731: 1,
    3732: 7,
    3733: 2,
    3735: 1,
    3736: 0,
    3737: 0,
    3738: 0,
    3739: 0,
    3741: 1,
    3743: 1,
    3745: 3,
    3748: 0,
    3750: 1,
    3754: 0,
    3756: 0,
    3757: 0,
    3761: 0,
    3762: 0,
    3763: 2,
    3765: 0,
    3766: 8,
    3767: 1,
    3769: 0,
    3773: 0,
    3777: 2,
    3778: 2,
    3781: 0,
    3784: 2,
    3788: 0,
    3789: 3,
    3792: 0,
    3794: 2,
    3796: 0,
    3802: 0,
    3803: 2,
    3808: 0,
    3809: 0,
    3810: 0,
    3811: 0,
    3812: 5,
    3819: 0,
    3821: 1,
    3822: 4,
    3823: 1,
    3824: 1,
    3827: 0,
    3828: 0,
    3831: 0,
    3832: 3,
    3833: 1,
    3834: 0,
    3835: 3,
    3836: 0,
    3842: 0,
    3843: 0,
    3845: 0,
    3847: 1,
    3849: 3,
    3852: 10,
    3853: 1,
    3854: 2,
    3860: 0,
    3863: 0,
    3865: 0,
    3868: 0,
    3869: 0,
    3870: 0,
    3876: 0,
    3882: 3,
    3884: 0,
    3885: 4,
    3887: 2,
    3888: 2,
    3889: 1,
    3890: 7,
    3893: 0,
    3895: 8,
    3896: 8,
    3897: 8,
    3898: 1,
    3899: 1,
    3900: 5,
    3901: 2,
    3903: 0,
    3907: 0,
    3909: 1,
    3913: 0,
    3921: 0,
    3922: 0,
    3925: 0,
    3929: 0,
    3932: 1,
    3933: 2,
    3938: 2,
    3940: 0,
    3941: 2,
    3942: 3,
    3944: 0,
    3955: 1,
    3956: 1,
    3957: 0,
    3958: 0,
    3959: 0,
    3960: 0,
    3961: 0,
    3962: 0,
    3963: 0,
    3964: 0,
    3965: 0,
    3966: 0,
    3967: 0,
    3968: 0,
    3969: 0,
    3970: 0,
    3971: 0,
    3972: 0,
    3973: 0,
    3974: 0,
    3975: 0,
    3976: 0,
    3977: 0,
    3978: 0,
    3979: 0,
    3980: 0,
    3981: 0,
    3982: 0,
    3983: 0,
    3984: 0,
    3985: 0,
    3986: 0,
    3987: 0,
    3988: 0,
    3989: 0,
    3990: 0,
    3991: 0,
    3992: 0,
    3994: 0,
    3997: 0,
    3998: 2,
    4003: 1,
    4007: 0,
    4008: 0,
    4011: 0,
    4012: 0,
    4014: 0,
    4016: 0,
    4020: 2,
    4024: 0,
    4025: 0,
    4026: 4,
    4027: 3,
    4029: 0,
    4032: 0,
    4033: 0,
    4034: 15,
    4038: 2,
    4039: 2,
    4040: 0,
    4041: 0,
    4050: 3,
    4051: 1,
    4063: 0,
    4067: 0,
    4069: 0,
    4071: 0,
    4072: 1,
    4073: 1,
    4075: 0,
    4077: 0,
    4084: 5,
    4085: 1,
    4090: 0,
    4093: 0,
    4096: 0,
    4099: 0,
    4101: 1,
    4102: 1,
    4103: 0,
    4104: 2,
    4106: 1,
    4107: 1,
    4108: 1,
    4113: 1,
    4114: 0,
    4116: 2,
    4117: 2,
    4118: 2,
    4119: 2,
    4120: 1,
    4122: 0,
    4127: 0,
    4128: 0,
    4129: 1,
    4130: 2,
    4136: 0,
    4137: 2,
    4140: 0,
    4144: 0,
    4145: 0,
    4148: 2,
    4150: 0,
    4151: 0,
    4156: 2,
    4159: 0,
    4160: 0,
    4161: 0,
    4162: 0,
    4163: 0,
    4164: 0,
    4165: 8,
    4166: 8,
    4167: 3,
    4168: 3,
    4169: 8,
    4170: 8,
    4171: 3,
    4172: 8,
    4173: 3,
    4174: 8,
    4175: 3,
    4176: 8,
    4179: 0,
    4180: 2,
    4181: 3,
    4182: 0,
    4184: 2,
    4187: 0,
    4188: 2,
    4191: 0,
    4194: 0,
    4197: 0,
    4200: 0,
    4204: 0,
    4205: 0,
    4206: 0,
    4207: 0,
    4208: 6,
    4211: 1,
    4212: 0,
    4215: 0,
    4223: 0,
    4225: 0,
    4230: 0,
    4234: 16,
    4237: 10,
    4238: 10,
    4240: 1,
    4241: 10,
    4244: 10,
    4250: 0,
    4253: 0,
    4259: 1,
    4261: 2,
    4262: 2,
    4263: 3,
    4266: 1,
    4268: 15,
    4269: 8,
    4270: 0,
    4271: 2,
    4273: 1,
    4274: 1,
    4276: 1,
    4282: 0,
    4283: 0,
    4292: 0,
    4295: 0,
    4298: 0,
    4303: 0,
    4304: 0,
    4306: 2,
    4308: 1,
    4309: 1,
    4310: 1,
    4311: 0,
    4312: 2,
    4313: 0,
    4314: 8,
    4315: 1,
    4316: 0,
    4318: 0,
    4319: 0,
    4322: 0,
    4325: 0,
    4326: 0,
    4329: 1,
    4334: 0,
    4337: 1,
    4338: 1,
    4339: 1,
    4342: 2,
    4361: 0,
    4362: 3,
    4364: 3,
    4365: 2,
    4370: 0,
    4371: 0,
    4376: 5,
    4377: 5,
    4378: 5,
    4379: 5,
    4380: 5,
    4381: 5,
    4382: 5,
    4383: 2,
    4385: 2,
    4388: 1,
    4390: 2,
    4391: 3,
    4393: 0,
    4395: 1,
    4397: 1,
    4398: 1,
    4400: 3,
    4403: 0,
    4406: 0,
    4409: 0,
    4410: 0,
    4411: 0,
    4413: 3,
    4416: 1,
    4417: 1,
    4418: 1,
    4419: 1,
    4423: 1,
    4426: 1,
    4429: 0,
    4432: 0,
    4433: 2,
    4438: 0,
    4439: 0,
    4440: 0,
    4441: 0,
    4444: 0,
    4448: 0,
    4451: 0,
    4453: 1,
    4454: 3,
    4456: 0,
    4457: 0,
    4458: 0,
    4464: 1,
    4471: 1,
    4472: 1,
    4473: 1,
    4474: 1,
    4475: 1,
    4476: 1,
    4477: 1,
    4478: 1,
    4479: 1,
    4480: 1,
    4481: 1,
    4488: 0,
    4489: 0,
    4491: 2,
    4493: 2,
    4495: 0,
    4499: 1,
    4501: 12,
    4502: 1,
    4503: 1,
    4504: 0,
    4507: 1,
    4508: 2,
    4509: 3,
    4514: 2,
    4515: 0,
    4518: 1,
    4521: 0,
    4524: 0,
    4528: 9,
    4529: 9,
    4534: 0,
    4536: 0,
    4537: 0,
    4538: 0,
    4539: 0,
    4540: 1,
    4541: 2,
    4543: 0,
    4545: 2,
    4547: 0,
    4549: 0,
    4550: 6,
    4551: 4,
    4552: 2,
    4553: 2,
    4554: 0,
    4555: 1,
    4556: 12,
    4557: 10,
    4558: 15,
    4559: 12,
    4561: 11,
    4562: 0,
    4563: 1,
    4570: 3,
    4571: 3,
    4572: 1,
    4573: 2,
    4574: 7,
    4575: 7,
    4576: 4,
    4577: 6,
    4578: 3,
    4579: 2,
    4580: 2,
    4581: 3,
    4582: 0,
    4584: 3,
    4587: 1,
    4591: 0,
    4593: 1,
    4594: 0,
    4596: 0,
    4599: 2,
    4603: 0,
    4611: 0,
    4614: 0,
    4623: 0,
    4624: 6,
    4627: 0,
    4629: 0,
    4631: 0,
    4632: 1,
    4635: 0,
    4636: 0,
    4637: 0,
    4638: 0,
    4647: 0,
    4649: 0,
    4653: 0,
    4655: 0,
    4669: 0,
    4670: 0,
    4671: 0,
    4676: 1,
    4683: 0,
    4684: 0,
    4688: 3,
    4689: 2,
    4690: 3,
    4691: 3,
    4693: 1,
    4696: 0,
    4698: 3,
    4699: 4,
    4700: 2,
    4701: 3,
    4704: 0,
    4705: 1,
    4709: 15,
    4710: 15,
    4711: 2,
    4712: 2,
    4713: 2,
    4714: 2,
    4721: 3,
    4722: 3,
    4723: 2,
    4725: 1,
    4727: 3,
    4728: 0,
    4730: 0,
    4731: 2,
    4732: 0,
    4733: 1,
    4734: 7,
    4745: 0,
    4757: 0,
    4763: 0,
    4764: 0,
    4765: 0,
    4768: 0,
    4769: 0,
    4770: 0,
    4772: 0,
    4773: 0,
    4774: 2,
    4775: 0,
    4776: 0,
    4777: 0,
    4781: 0,
    4787: 0,
    4788: 0,
    4789: 0,
    4790: 1,
    4792: 0,
    4793: 0,
    4794: 0,
    4795: 0,
    4801: 0,
    4802: 0,
    4803: 0,
    4804: 0,
    4811: 0,
    4812: 4,
    4813: 3,
    4817: 0,
    4822: 0,
    4829: 0,
    4833: 0,
    4840: 0,
    4841: 0,
    4842: 0,
    4843: 0,
    4844: 0,
    4845: 0,
    4846: 0,
    4847: 0,
    4848: 0,
    4849: 0,
    4850: 0,
    4851: 0,
    4852: 0,
    4854: 1,
    4855: 0,
    4856: 0,
    4857: 0,
    4858: 0,
    4859: 1,
    4860: 2,
    4862: 4,
    4864: 0,
    4865: 3,
    4866: 3,
    4867: 0,
    4868: 3,
    4870: 0,
    4871: 4,
    4872: 1,
    4873: 1,
    4875: 0,
    4876: 0,
    4878: 0,
    4883: 2,
    4885: 0,
    4886: 0,
    4889: 0,
    4890: 0,
    4892: 0,
    4894: 0,
    4896: 9,
    4898: 0,
    4900: 0,
    4901: 12,
    4903: 2,
    4904: 0,
    4907: 0,
    4912: 3,
    4913: 10,
    4915: 0,
    4916: 1,
    4918: 0,
    4919: 1,
    4921: 1,
    4922: 0,
    4923: 2,
    4929: 12,
    4931: 2,
    4933: 2,
    4939: 0,
    4942: 2,
    4943: 1,
    4950: 0,
    4953: 0,
    4954: 2,
    4956: 0,
    4959: 2,
    4963: 1,
    4965: 0,
    4966: 0,
    4969: 0,
    4971: 0,
    4973: 0,
    4975: 0,
    4979: 1,
    4980: 0,
    4981: 0,
    4983: 0,
    4985: 0,
    4986: 2,
    4989: 1,
    4990: 7,
    4991: 0,
    4992: 2,
    4994: 3,
    4995: 7,
    4996: 5,
    4997: 1,
    5001: 3,
    5002: 3,
    5014: 0,
    5016: 0,
    5019: 0,
    5020: 0,
    5025: 2,
    5026: 2,
    5027: 0,
    5028: 1,
    5029: 1,
    5030: 1,
    5031: 1,
    5032: 1,
    5042: 3,
    5048: 0,
    5051: 0,
    5053: 0,
    5055: 0,
    5059: 0,
    5060: 0,
    5067: 3,
    5104: 2,
    5107: 0,
    5109: 1,
    5111: 3,
    5113: 1,
    5115: 0,
    5117: 1,
    5120: 0,
    5122: 6,
    5124: 4,
    5125: 2,
    5126: 2,
    5127: 15,
    5131: 0,
    5133: 0,
    5135: 0,
    5138: 2,
    5147: 2,
    5148: 0,
    5151: 0,
    5155: 0,
    5167: 0,
    5168: 3,
    5175: 0,
    5178: 0,
    5179: 0,
    5180: 0,
    5181: 1,
    5183: 0,
    5184: 0,
    5187: 0,
    5190: 0,
    5192: 0,
    5193: 0,
    5195: 1,
    5198: 0,
    5199: 0,
    5200: 0,
    5202: 0,
    5205: 0,
    5207: 1,
    5208: 2,
    5209: 2,
    5210: 2,
    5211: 0,
    5212: 5,
    5219: 0,
    5222: 0,
    5224: 2,
    5225: 0,
    5227: 0,
    5230: 2,
    5236: 2,
    5237: 1,
    5240: 2,
    5242: 0,
    5244: 0,
    5246: 2,
    5247: 2,
    5248: 3,
    5249: 3,
    5250: 4,
    5257: 1,
    5259: 0,
    5260: 2,
    5262: 0,
    5264: 0,
    5265: 0,
    5266: 0,
    5267: 0,
    5268: 0,
    5269: 0,
    5270: 2,
    5272: 3,
    5275: 2,
    5277: 2,
    5279: 2,
    5281: 2,
    5283: 2,
    5285: 2,
    5288: 3,
    5289: 3,
    5290: 0,
    5291: 0,
    5293: 0,
    5294: 0,
    5301: 0,
    5302: 2,
    5303: 2,
    5304: 2,
    5307: 0,
    5309: 1,
    5311: 0,
    5312: 0,
    5313: 0,
    5316: 0,
    5317: 6,
    5318: 0,
    5321: 0,
    5322: 0,
    5325: 0,
    5331: 0,
    5335: 0,
    5336: 0,
    5337: 0,
    5338: 0,
    5339: 0,
    5340: 0,
    5341: 0,
    5344: 0,
    5350: 0,
    5351: 0,
    5353: 1,
    5354: 1,
    5355: 1,
    5356: 0,
    5357: 0,
    5358: 0,
    5361: 0,
    5363: 0,
    5365: 0,
    5367: 0,
    5368: 2,
    5369: 0,
    5372: 1,
    5374: 1,
    5375: 0,
    5376: 7,
    5377: 1,
    5379: 1,
    5383: 0,
    5384: 2,
    5385: 2,
    5386: 2,
    5387: 2,
    5388: 2,
    5389: 2,
    5390: 0,
    5393: 8,
    5395: 0,
    5399: 2,
    5400: 1,
    5401: 1,
    5410: 10,
    5411: 1,
    5413: 0,
    5414: 0,
    5416: 2,
    5417: 2,
    5422: 2,
    5433: 9,
    5445: 1,
    5448: 10,
    5454: 1,
    5455: 1,
    5456: 1,
    5465: 7,
    5466: 0,
    5468: 2,
    5475: 0,
    5498: 0,
    5499: 0,
    5501: 0,
    5504: 0,
    5505: 0,
    5507: 3,
    5508: 3,
    5510: 0,
    5512: 0,
    5514: 0,
    5518: 0,
    5522: 0,
    5526: 0,
    5528: 0,
    5529: 0,
    5531: 1,
    5532: 1,
    5533: 1,
    5534: 1,
    5537: 0,
    5538: 0,
    5539: 11,
    5542: 0,
    5543: 1,
    5545: 2,
    5546: 0,
    5548: 0,
    5552: 0,
    5553: 0,
    5554: 2,
    5555: 10,
    5556: 10,
    5559: 3,
    5566: 3,
    5572: 0,
    5575: 0,
    5578: 0,
    5581: 0,
    5582: 0,
    5583: 1,
    5585: 1,
    5586: 1,
    5587: 1,
    5590: 1,
    5591: 2,
    5592: 14,
    5593: 3,
    5595: 3,
    5598: 0,
    5599: 2,
    5600: 0,
    5601: 0,
    5603: 0,
    5604: 1,
    5607: 4,
    5608: 2,
    5609: 0,
    5610: 0,
    5611: 0,
    5612: 6,
    5613: 0,
    5614: 2,
    5615: 4,
    5616: 2,
    5617: 2,
    5618: 3,
    5619: 3,
    5620: 1,
    5621: 1,
    5623: 0,
    5624: 0,
    5625: 0,
    5626: 0,
    5627: 0,
    5629: 0,
    5631: 0,
    5635: 2,
    5637: 0,
    5639: 0,
    5644: 0,
    5647: 0,
    5650: 0,
    5653: 0,
    5655: 0,
    5657: 1,
    5658: 1,
    5666: 3,
    5667: 0,
    5673: 0,
    5674: 0,
    5675: 0,
    5678: 0,
    5679: 2,
    5680: 1,
    5681: 1,
    5685: 0,
    5686: 0,
    5691: 0,
    5692: 1,
    5693: 0,
    5695: 1,
    5698: 0,
    5706: 0,
    5708: 1,
    5711: 1,
    5712: 1,
    5714: 3,
    5715: 3,
    5716: 3,
    5717: 3,
    5718: 3,
    5719: 0,
    5720: 0,
    5725: 1,
    5727: 2,
    5730: 0,
    5731: 1,
    5732: 0,
    5739: 0,
    5740: 0,
    5742: 0,
    5748: 0,
    5749: 0,
    5751: 0,
    5753: 0,
    5754: 0,
    5762: 0,
    5764: 0,
    5765: 0,
    5766: 1,
    5767: 0,
    5771: 0,
    5772: 0,
    5773: 0,
    5774: 0,
    5775: 0,
    5776: 0,
    5777: 0,
    5784: 0,
    5786: 0,
    5789: 0,
    5790: 0,
    5791: 0,
    5792: 0,
    5794: 0,
    5799: 0,
    5800: 11,
    5802: 0,
    5804: 0,
    5805: 0,
    5810: 0,
    5811: 0,
    5812: 1,
    5816: 0,
    5818: 0,
    5819: 0,
    5820: 1,
    5821: 3,
    5822: 2,
    5823: 1,
    5824: 1,
    5825: 1,
    5833: 3,
    5835: 3,
    5837: 0,
    5838: 3,
    5840: 3,
    5843: 0,
    5844: 0,
    5849: 0,
    5851: 2,
    5855: 1,
    5856: 1,
    5857: 1,
    5858: 1,
    5860: 2,
    5861: 0,
    5863: 0,
    5864: 0,
    5865: 0,
    5866: 0,
    5871: 1,
    5873: 1,
    5876: 1,
    5877: 1,
    5878: 0,
    5882: 0,
    5884: 2,
    5885: 1,
    5886: 1,
    5887: 0,
    5890: 0,
    5891: 0,
    5892: 0,
    5894: 0,
    5895: 0,
    5896: 0,
    5897: 0,
    5898: 8,
    5899: 8,
    5900: 1,
    5901: 2,
    5902: 2,
    5903: 15,
    5904: 2,
    5905: 2,
    5906: 9,
    5907: 2,
    5908: 2,
    5910: 0,
    5912: 2,
    5914: 1,
    5923: 2,
    5924: 2,
    5925: 1,
    5926: 1,
    5927: 1,
    5928: 1,
    5932: 1,
    5934: 0,
    5936: 0,
    5937: 0,
    5938: 1,
    5943: 0,
    5944: 0,
    5945: 0,
    5955: 0,
    5957: 0,
    5959: 0,
    5961: 0,
    5963: 0,
    5968: 0,
    5969: 2,
    5977: 2,
    5978: 0,
    5979: 0,
    5982: 13,
    5983: 13,
    5984: 10,
    5985: 10,
    5986: 7,
    5987: 7,
    5988: 9,
    5989: 9,
    5990: 9,
    5991: 9,
    5998: 1,
    6000: 0,
    6001: 0,
    6002: 0,
    6003: 0,
    6006: 0,
    6007: 2,
    6008: 0,
    6009: 1,
    6011: 0,
    6012: 2,
    6019: 2,
    6021: 13,
    6023: 13,
    6026: 1,
    6037: 1,
    6038: 1,
    6042: 1,
    6043: 12,
    6048: 2,
    6050: 2,
    6052: 2,
    6055: 0,
    6059: 1,
    6060: 1,
    6061: 0,
    6062: 0,
    6064: 0,
    6065: 6,
    6066: 6,
    6070: 0,
    6072: 3,
    6074: 3,
    6076: 3,
    6077: 0,
    6078: 9,
    6079: 9,
    6080: 9,
    6081: 9,
    6082: 9,
    6083: 10,
    6084: 10,
    6085: 10,
    6086: 10,
    6087: 1,
    6088: 1,
    6089: 1,
    6090: 1,
    6091: 13,
    6092: 10,
    6093: 10,
    6094: 10,
    6095: 7,
    6096: 7,
    6097: 10,
    6101: 0,
    6103: 0,
    6105: 0,
    6106: 0,
    6107: 0,
    6108: 0,
    6109: 0,
    6115: 6,
    6126: 0,
    6127: 0,
    6128: 0,
    6130: 0,
    6131: 0,
    6133: 0,
    6134: 0,
    6136: 1,
    6137: 1,
    6140: 0,
    6141: 0,
    6142: 0,
    6143: 0,
    6144: 0,
    6154: 0,
    6155: 0,
    6156: 0,
    6157: 0,
    6161: 1,
    6162: 1,
    6163: 0,
    6164: 1,
    6165: 0,
    6166: 1,
    6167: 12,
    6170: 13,
    6171: 2,
    6172: 7,
    6174: 3,
    6175: 0,
    6176: 0,
    6183: 2,
    6185: 2,
    6186: 0,
    6187: 3,
    6188: 3,
    6190: 3,
    6191: 1,
    6193: 0,
    6194: 14,
    6195: 2,
    6196: 2,
    6199: 0,
    6200: 0,
    6202: 2,
    6204: 9,
    6207: 2,
    6208: 2,
    6209: 2,
    6210: 0,
    6212: 4,
    6214: 2,
    6217: 0,
    6219: 0,
    6222: 0,
    6224: 0,
    6225: 0,
    6230: 0,
    6232: 0,
    6235: 1,
    6237: 1,
    6239: 2,
    6240: 7,
    6241: 7,
    6242: 0,
    6244: 0,
    6245: 1,
    6247: 5,
    6248: 5,
    6251: 4,
    6252: 1,
    6253: 1,
    6254: 4,
    6256: 2,
    6257: 2,
    6258: 2,
    6260: 10,
    6261: 1,
    6262: 1,
    6263: 1,
    6264: 11,
    6265: 11,
    6266: 17,
    6270: 3,
    6271: 0,
    6272: 2,
    6273: 16,
    6274: 2,
    6280: 0,
    6283: 1,
    6291: 12,
    6296: 0,
    6297: 0,
    6299: 0,
    6302: 0,
    6311: 0,
    6312: 0,
    6319: 2,
    6320: 1,
    6321: 1,
    6323: 1,
    6324: 1,
    6327: 2,
    6329: 0,
    6330: 1,
    6331: 2,
    6332: 2,
    6333: 7,
    6336: 0,
    6337: 0,
    6338: 0,
    6339: 0,
    6340: 0,
    6341: 1,
    6342: 0,
    6344: 0,
    6347: 2,
    6349: 1,
    6351: 0,
    6352: 0,
    6353: 0,
    6354: 0,
    6355: 0,
    6356: 0,
    6357: 0,
    6359: 3,
    6360: 1,
    6364: 3,
    6367: 2,
    6371: 2,
    6373: 0,
    6375: 2,
    6376: 1,
    6378: 0,
    6380: 0,
    6384: 1,
    6386: 2,
    6388: 1,
    6397: 0,
    6399: 1,
    6401: 0,
    6402: 7,
    6403: 0,
    6406: 1,
    6412: 0,
    6418: 0,
    6420: 0,
    6421: 0,
    6422: 0,
    6423: 0,
    6424: 0,
    6425: 0,
    6427: 0,
    6428: 2,
    6429: 1,
    6430: 3,
    6431: 0,
    6432: 2,
    6435: 1,
    6438: 1,
    6439: 0,
    6441: 1,
    6447: 0,
    6448: 0,
    6449: 0,
    6457: 0,
    6459: 0,
    6461: 0,
    6463: 0,
    6465: 0,
    6468: 0,
    6476: 0,
    6480: 2,
    6491: 0,
    6492: 0,
    6493: 0,
    6495: 3,
    6504: 2,
    6507: 1,
    6509: 0,
    6510: 1,
    6514: 0,
    6515: 2,
    6518: 1,
    6522: 2,
    6523: 2,
    6524: 2,
    6525: 2,
    6526: 2,
    6529: 1,
    6531: 2,
    6536: 1,
    6539: 1,
    6544: 0,
    6548: 0,
    6549: 12,
    6550: 1,
    6553: 1,
    6554: 0,
    6555: 3,
    6556: 0,
    6564: 1,
    6566: 2,
    6568: 3,
    6569: 0,
    6570: 0,
    6576: 1,
    6578: 3,
    6579: 2,
    6583: 13,
    6586: 2,
    6587: 2,
    6590: 0,
    6594: 2,
    6595: 0,
    6596: 2,
    6601: 2,
    6602: 2,
    6603: 2,
    6604: 2,
    6605: 2,
    6606: 2,
    6608: 3,
    6610: 0,
    6612: 1,
    6613: 1,
    6614: 1,
    6616: 2,
    6617: 3,
    6620: 2,
    6623: 2,
    6625: 0,
    6627: 2,
    6628: 0,
    6629: 0,
    6630: 10,
    6631: 0,
    6632: 12,
    6635: 0,
    6636: 0,
    6637: 0,
    6643: 0,
    6644: 0,
    6646: 0,
    6647: 2,
    6649: 0,
    6651: 0,
    6652: 0,
    6657: 0,
    6662: 1,
    6666: 0,
    6667: 0,
    6670: 1,
    6672: 0,
    6683: 7,
    6684: 3,
    6685: 0,
    6686: 1,
    6687: 2,
    6688: 2,
    6689: 1,
    6690: 1,
    6691: 2,
    6692: 0,
    6694: 3,
    6695: 3,
    6696: 3,
    6697: 3,
    6699: 2,
    6701: 1,
    6702: 3,
    6708: 0,
    6718: 1,
    6721: 1,
    6722: 1,
    6724: 0,
    6725: 0,
    6727: 1,
    6728: 0,
    6729: 0,
    6731: 0,
    6738: 0,
    6740: 0,
    6743: 0,
    6747: 0,
    6750: 0,
    6754: 0,
    6755: 2,
    6756: 2,
    6758: 2,
    6759: 2,
    6760: 5,
    6761: 1,
    6763: 2,
    6766: 4,
    6769: 0,
    6770: 3,
    6772: 2,
    6773: 2,
    6774: 2,
    6776: 2,
    6782: 0,
    6783: 0,
    6784: 0,
    6796: 1,
    6800: 2,
    6802: 0,
    6804: 2,
    6805: 0,
    6807: 0,
    6814: 1,
    6816: 1,
    6817: 2,
    6820: 1,
    6821: 0,
    6823: 0,
    6832: 1,
    6833: 1,
    6835: 5,
    6836: 9,
    6838: 0,
    6847: 0,
    6848: 3,
    6849: 0,
    6850: 4,
    6853: 0,
    6855: 0,
    6858: 0,
    6862: 1,
    6863: 6,
    6866: 1,
    6867: 1,
    6868: 0,
    6869: 1,
    6871: 0,
    6876: 0,
    6883: 0,
    6884: 3,
    6885: 2,
    6887: 2,
    6889: 2,
    6892: 1,
    6893: 1,
    6894: 1,
    6895: 1,
    6898: 1,
    6902: 1,
    6907: 1,
    6910: 0,
    6912: 3,
    6913: 2,
    6915: 1,
    6919: 3,
    6920: 3,
    6921: 3,
    6923: 0,
    6927: 0,
    6929: 0,
    6932: 0,
    6933: 0,
    6941: 0,
    6944: 0,
    6946: 0,
    6948: 0,
    6950: 0,
    6952: 0,
    6954: 0,
    6956: 0,
    6958: 0,
    6959: 0,
    6960: 0,
    6961: 0,
    6965: 0,
    6966: 0,
    6967: 0,
    6973: 0,
    6974: 0,
    6975: 0,
    6977: 0,
    6978: 1,
    6979: 1,
    6980: 1,
    6982: 9,
    6983: 1,
    6985: 1,
    6986: 0,
    6990: 0,
    6991: 0,
    6992: 0,
    6995: 1,
    7003: 3,
    7004: 0,
    7009: 0,
    7012: 0,
    7018: 0,
    7019: 7,
    7021: 2,
    7023: 2,
    7024: 3,
    7029: 2,
    7032: 1,
    7033: 1,
    7035: 2,
    7041: 1,
    7051: 2,
    7053: 1,
    7054: 1,
    7055: 0,
    7057: 2,
    7058: 1,
    7060: 2,
    7062: 2,
    7068: 0,
    7069: 1,
    7075: 1,
    7078: 7,
    7081: 0,
    7082: 2,
    7090: 0,
    7097: 0,
    7101: 0,
    7102: 0,
    7104: 0,
    7107: 0,
    7109: 0,
    7111: 0,
    7113: 0,
    7115: 0,
    7117: 0,
    7119: 0,
    7121: 0,
    7123: 0,
    7125: 0,
    7127: 0,
    7129: 0,
    7134: 0,
    7135: 1,
    7137: 0,
    7141: 0,
    7164: 1,
    7165: 1,
    7167: 1,
    7170: 0,
    7175: 2,
    7176: 0,
    7178: 0,
    7183: 1,
    7184: 0,
    7186: 0,
    7188: 0,
    7189: 0,
    7218: 9,
    7220: 9,
    7221: 9,
    7222: 9,
    7223: 9,
    7224: 9,
    7225: 9,
    7226: 9,
    7228: 0,
    7229: 2,
    7232: 2,
    7238: 0,
    7239: 0,
    7241: 0,
    7243: 0,
    7245: 0,
    7246: 1,
    7248: 0,
    7251: 0,
    7252: 0,
    7253: 1,
    7255: 1,
    7267: 1,
    7268: 1,
    7269: 1,
    7270: 1,
    7271: 1,
    7272: 1,
    7273: 1,
    7274: 1,
    7275: 9,
    7276: 9,
    7277: 9,
    7278: 9,
    7279: 1,
    7280: 9,
    7281: 9,
    7282: 9,
    7285: 1,
    7289: 3,
    7291: 1,
    7295: 0,
    7297: 0,
    7300: 0,
    7301: 0,
    7303: 0,
    7308: 0,
    7309: 0,
    7314: 0,
    7316: 0,
    7319: 0,
    7320: 9,
    7321: 1,
    7323: 0,
    7332: 3,
    7333: 0,
    7349: 1,
    7350: 1,
    7351: 1,
    7352: 1,
    7354: 1,
    7355: 7,
    7360: 1,
    7361: 1,
    7362: 1,
    7365: 1,
    7367: 0,
    7370: 0,
    7371: 0,
    7372: 0,
    7373: 2,
    7375: 0,
    7379: 1,
    7380: 1,
    7381: 1,
    7382: 1,
    7383: 1,
    7386: 1,
    7388: 0,
    7390: 0,
    7393: 0,
    7394: 0,
    7395: 0,
    7398: 0,
    7402: 1,
    7403: 1,
    7405: 0,
    7409: 1,
    7410: 1,
    7411: 1,
    7414: 0,
    7416: 0,
    7419: 0,
    7420: 2,
    7421: 1,
    7422: 1,
    7425: 0,
    7428: 1,
    7429: 0,
    7435: 0,
    7437: 1,
    7438: 0,
    7441: 1,
    7443: 0,
    7451: 2,
    7453: 1,
    7456: 3,
    7463: 1,
    7468: 1,
    7479: 1,
    7480: 1,
    7495: 2,
    7496: 2,
    7497: 1,
    7501: 1,
    7502: 1,
    7503: 9,
    7504: 0,
    7520: 1,
    7521: 1,
    7522: 1,
    7523: 1,
    7524: 1,
    7525: 1,
    7526: 1,
    7527: 1,
    7538: 6,
    7539: 1,
    7546: 0,
    7547: 0,
    7548: 0,
    7549: 0,
    7550: 0,
    7551: 0,
    7553: 0,
    7558: 1,
    7559: 0,
    7564: 2,
    7565: 2,
    7566: 1,
    7568: 2,
    7584: 0,
    7591: 0,
    7594: 0,
    7599: 0,
    7600: 1,
    7603: 1,
    7608: 0,
    7611: 2,
    7613: 2,
    7614: 9,
    7619: 2,
    7620: 2,
    7621: 2,
    7622: 2,
    7624: 0,
    7627: 0,
    7632: 0,
    7633: 0,
    7634: 0,
    7639: 0,
    7640: 1,
    7641: 0,
    7643: 2,
    7645: 0,
    7647: 0,
    7650: 6,
    7652: 0,
    7654: 2,
    7656: 2,
    7657: 2,
    7658: 3,
    7664: 2,
    7666: 2,
    7668: 3,
    7671: 0,
    7673: 0,
    7676: 0,
    7682: 0,
    7684: 0,
    7685: 1,
    7687: 0,
    7698: 0,
    7700: 0,
    7703: 0,
    7704: 0,
    7710: 0,
    7712: 6,
    7715: 0,
    7718: 1,
    7719: 1,
    7721: 1,
    7722: 8,
    7723: 0,
    7727: 0,
    7731: 0,
    7734: 0,
    7735: 0,
    7736: 3,
    7742: 0,
    7743: 0,
    7744: 0,
    7747: 1,
    7748: 0,
    7749: 0,
    7750: 0,
    7751: 0,
    7752: 0,
    7753: 0,
    7754: 3,
    7755: 1,
    7758: 0,
    7760: 0,
    7763: 0,
    7765: 1,
    7767: 0,
    7770: 0,
    7772: 3,
    7776: 1,
    7777: 1,
    7779: 0,
    7781: 0,
    7783: 0,
    7784: 0,
    7785: 0,
    7790: 0,
    7791: 1,
    7792: 0,
    7793: 2,
    7799: 1,
    7803: 0,
    7807: 0,
    7808: 0,
    7810: 0,
    7811: 1,
    7816: 2,
    7817: 0,
    7820: 1,
    7823: 0,
    7831: 1,
    7833: 0,
    7834: 0,
    7835: 0,
    7836: 0,
    7839: 0,
    7847: 2,
    7848: 2,
    7852: 1,
    7853: 1,
    7854: 1,
    7855: 1,
    7858: 1,
    7861: 0,
    7864: 0,
    7866: 1,
    7868: 0,
    7869: 1,
    7870: 0,
    7873: 0,
    7874: 0,
    7875: 0,
    7876: 0,
    7877: 5,
    7879: 1,
    7881: 0,
    7884: 0,
    7886: 0,
    7887: 1,
    7888: 1,
    7890: 9,
    7893: 0,
    7895: 1,
    7896: 0,
    7897: 0,
    7898: 3,
    7902: 6,
    7903: 1,
    7904: 1,
    7907: 0,
    7908: 0,
    7911: 0,
    7913: 1,
    7914: 0,
    7918: 0,
    7919: 0,
    7920: 2,
    7921: 0,
    7923: 1,
    7925: 0,
    7927: 0,
    7928: 0,
    7931: 0,
    7933: 0,
    7934: 1,
    7935: 4,
    7938: 0,
    7940: 1,
    7941: 1,
    7942: 0,
    7944: 1,
    7948: 1,
    7949: 1,
    7950: 1,
    7951: 0,
    7954: 1,
    7955: 2,
    7956: 2,
    7957: 2,
    7961: 2,
    7963: 1,
    7965: 9,
    7966: 9,
    7970: 1,
    7974: 1,
    7975: 1,
    7979: 1,
    7981: 0,
    7983: 0,
    7988: 1,
    7991: 7,
    7992: 15,
    7993: 3,
    7994: 3,
    7997: 6,
    8007: 1,
    8008: 0,
    8011: 2,
    8013: 0,
    8014: 7,
    8015: 2,
    8019: 1,
    8023: 2,
    8024: 7,
    8025: 0,
    8027: 0,
    8033: 1,
    8034: 0,
    8037: 1,
    8040: 11,
    8041: 0,
    8046: 0,
    8047: 1,
    8048: 1,
    8054: 2,
    8057: 0,
    8059: 1,
    8060: 8,
    8061: 8,
    8067: 2,
    8068: 2,
    8070: 0,
    8072: 0,
    8074: 3,
    8075: 2,
    8079: 2,
    8081: 2,
    8085: 3,
    8086: 3,
    8091: 1,
    8099: 0,
    8103: 1,
    8104: 15,
    8105: 0,
    8108: 1,
    8113: 1,
    8125: 1,
    8127: 1,
    8131: 2,
    8135: 2,
    8137: 3,
    8138: 0,
    8140: 0,
    8145: 3,
    8146: 2,
    8147: 2,
    8148: 8,
    8149: 8,
    8152: 1,
    8157: 1,
    8158: 0,
    8159: 0,
    8163: 0,
    8165: 0,
    8170: 0,
    8171: 0,
    8173: 0,
    8175: 0,
    8178: 0,
    8180: 0,
    8181: 0,
    8183: 2,
    8185: 1,
    8194: 1,
    8195: 0,
    8197: 1,
    8201: 0,
    8202: 2,
    8204: 2,
    8206: 0,
    8208: 0,
    8211: 0,
    8212: 0,
    8215: 0,
    8219: 0,
    8220: 1,
    8221: 0,
    8225: 2,
    8227: 0,
    8229: 1,
    8230: 8,
    8231: 5,
    8240: 7,
    8244: 2,
    8246: 2,
    8247: 0,
    8251: 2,
    8252: 1,
    8257: 1,
    8260: 1,
    8263: 0,
    8266: 0,
    8269: 0,
    8272: 2,
    8275: 0,
    8277: 0,
    8280: 0,
    8281: 0,
    8283: 0,
    8284: 0,
    8296: 0,
    8300: 0,
    8302: 0,
    8305: 0,
    8307: 0,
    8310: 1,
    8311: 0,
    8315: 0,
    8316: 1,
    8317: 3,
    8319: 2,
    8320: 1,
    8321: 0,
    8322: 0,
    8329: 0,
    8330: 0,
    8332: 0,
    8341: 0,
    8343: 2,
    8348: 0,
    8349: 1,
    8350: 7,
    8353: 2,
    8354: 4,
    8355: 3,
    8358: 0,
    8361: 1,
    8364: 1,
    8371: 4,
    8373: 0,
    8376: 0,
    8377: 0,
    8378: 3,
    8379: 0,
    8388: 0,
    8391: 8,
    8395: 1,
    8396: 0,
    8399: 1,
    8403: 3,
    8405: 3,
    8413: 1,
    8414: 0,
    8419: 0,
    8420: 8,
    8421: 8,
    8422: 8,
    8423: 8,
    8424: 1,
    8426: 0,
    8427: 0,
    8429: 0,
    8431: 1,
    8432: 1,
    8435: 2,
    8436: 2,
    8443: 1,
    8444: 1,
    8445: 1,
    8447: 1,
    8450: 0,
    8451: 0,
    8452: 0,
    8459: 2,
    8460: 0,
    8467: 0,
    8468: 2,
    8471: 2,
    8472: 0,
    8479: 4,
    8481: 4,
    8485: 1,
    8488: 1,
    8489: 0,
    8491: 2,
    8493: 0,
    8494: 0,
    8495: 1,
    8497: 1,
    8499: 5,
    8500: 2,
    8501: 0,
    8504: 1,
    8505: 1,
    8507: 0,
    8511: 1,
    8514: 1,
    8520: 0,
    8526: 0,
    8529: 2,
    8531: 0,
    8535: 0,
    8536: 0,
    8537: 1,
    8541: 3,
    8545: 2,
    8546: 3,
    8549: 0,
    8552: 0,
    8553: 1,
    8555: 1,
    8559: 0,
    8560: 1,
    8561: 0,
    8565: 0,
    8567: 0,
    8571: 0,
    8573: 1,
    8575: 1,
    8576: 0,
    8583: 0,
    8584: 0,
    8585: 2,
    8588: 1,
    8589: 1,
    8590: 3,
    8592: 7,
    8593: 3,
    8594: 1,
    8599: 1,
    8602: 0,
    8605: 2,
    8606: 0,
    8607: 2,
    8608: 0,
    8609: 0,
    8610: 2,
    8621: 0,
    8625: 1,
    8632: 1,
    8638: 0,
    8639: 1,
    8640: 0,
    8645: 0,
    8648: 2,
    8649: 1,
    8655: 0,
    8659: 3,
    8661: 2,
    8663: 0,
    8665: 1,
    8666: 1,
    8668: 1,
    8670: 0,
    8672: 1,
    8673: 0,
    8674: 0,
    8675: 0,
    8677: 0,
    8679: 3,
    8680: 3,
    8681: 3,
    8682: 3,
    8684: 0,
    8686: 3,
    8687: 1,
    8688: 1,
    8689: 5,
    8690: 6,
    8692: 2,
    8694: 0,
    8695: 1,
    8698: 2,
    8701: 0,
    8702: 1,
    8706: 0,
    8707: 0,
    8709: 0,
    8711: 0,
    8712: 0,
    8714: 0,
    8737: 1,
    8738: 1,
    8742: 0,
    8743: 0,
    8745: 1,
    8746: 0,
    8747: 0,
    8748: 0,
    8759: 0,
    8763: 1,
    8765: 2,
    8766: 2,
    8767: 2,
    8768: 0,
    8769: 0,
    8770: 0,
    8771: 2,
    8772: 0,
    8775: 3,
    8794: 0,
    8796: 4,
    8797: 7,
    8803: 3,
    8818: 0,
    8841: 0,
    8844: 1,
    8848: 1,
    8866: 1,
    8869: 1,
    8873: 0,
    8874: 0,
    8876: 1,
    8878: 2,
    8879: 2,
    8883: 0,
    8884: 1,
    8885: 1,
    8886: 1,
    8890: 1,
    8891: 1,
    8892: 1,
    8893: 3,
    8894: 3,
    8895: 4,
    8896: 4,
    8900: 4,
    8902: 0,
    8907: 0,
    8909: 0,
    8910: 1,
    8917: 2,
    8918: 1,
    8919: 1,
    8926: 1,
    8933: 0,
    8939: 2,
    8942: 3,
    8943: 3,
    8944: 3,
    8945: 3,
    8950: 0,
    8951: 4,
    8954: 3,
    8957: 0,
    8959: 1,
    8960: 0,
    8961: 0,
    8963: 1,
    8966: 1,
    8969: 1,
    8972: 0,
    8973: 0,
    8974: 1,
    8977: 4,
    8979: 0,
    8980: 0,
    8982: 1,
    8983: 1,
    8986: 1,
    8987: 1,
    8988: 0,
    8991: 1,
    8995: 0,
    8996: 0,
    8997: 0,
    8998: 0,
    8999: 0,
    9000: 0,
    9017: 0,
    9019: 0,
    9022: 0,
    9028: 3,
    9029: 14,
    9030: 2,
    9031: 3,
    9032: 0,
    9034: 2,
    9036: 0,
    9037: 2,
    9039: 0,
    9040: 0,
    9043: 3,
    9044: 0,
    9045: 0,
    9046: 0,
    9047: 0,
    9048: 0,
    9049: 0,
    9050: 0,
    9051: 0,
    9052: 0,
    9053: 0,
    9054: 0,
    9057: 0,
    9058: 0,
    9061: 1,
    9068: 1,
    9069: 1,
    9070: 0,
    9071: 1,
    9073: 1,
    9074: 1,
    9075: 1,
    9078: 13,
    9079: 1,
    9081: 1,
    9082: 0,
    9084: 0,
    9086: 2,
    9087: 1,
    9090: 1,
    9091: 4,
    9092: 1,
    9094: 0,
    9098: 0,
    9099: 3,
    9102: 2,
    9105: 0,
    9106: 0,
    9113: 0,
    9114: 0,
    9115: 0,
    9116: 0,
    9120: 0,
    9121: 0,
    9122: 0,
    9123: 0,
    9125: 0,
    9131: 2,
    9144: 0,
    9146: 6,
    9148: 3,
    9149: 3,
    9151: 4,
    9154: 0,
    9160: 0,
    9161: 0,
    9163: 0,
    9167: 0,
    9169: 0,
    9176: 1,
    9177: 0,
    9178: 0,
    9188: 0,
    9192: 0,
    9194: 0,
    9195: 0,
    9199: 2,
    9202: 0,
    9203: 0,
    9209: 0,
    9211: 1,
    9212: 0,
    9216: 17,
    9217: 14,
    9219: 1,
    9221: 0,
    9226: 0,
    9227: 0,
    9228: 0,
    9229: 0,
    9230: 1,
    9232: 1,
    9233: 1,
    9235: 0,
    9236: 2,
    9238: 9,
    9241: 1,
    9242: 0,
    9243: 2,
    9247: 4,
    9248: 2,
    9249: 2,
    9254: 0,
    9257: 2,
    9261: 0,
    9262: 0,
    9265: 1,
    9268: 1,
    9269: 1,
    9270: 1,
    9271: 0,
    9273: 0,
    9278: 1,
    9279: 1,
    9281: 0,
    9283: 0,
    9285: 1,
    9289: 0,
    9290: 0,
    9291: 0,
    9292: 2,
    9293: 1,
    9295: 0,
    9296: 0,
    9305: 0,
    9307: 0,
    9312: 2,
    9313: 3,
    9314: 3,
    9315: 2,
    9317: 1,
    9319: 1,
    9320: 1,
    9321: 2,
    9322: 1,
    9323: 1,
    9328: 1,
    9330: 1,
    9332: 1,
    9344: 0,
    9345: 0,
    9346: 0,
    9350: 0,
    9352: 0,
    9353: 2,
    9355: 0,
    9359: 1,
    9362: 1,
    9366: 3,
    9367: 4,
    9368: 2,
    9369: 3,
    9370: 2,
    9371: 2,
    9372: 2,
    9374: 2,
    9376: 1,
    9377: 1,
    9378: 2,
    9379: 3,
    9380: 2,
    9381: 2,
    9382: 3,
    9383: 1,
    9384: 0,
    9385: 0,
    9391: 1,
    9392: 0,
    9393: 1,
    9394: 1,
    9397: 1,
    9398: 1,
    9400: 0,
    9403: 0,
    9404: 0,
    9406: 1,
    9407: 2,
    9408: 1,
    9409: 9,
    9410: 9,
    9411: 9,
    9414: 2,
    9419: 0,
    9423: 0,
    9425: 2,
    9426: 0,
    9427: 1,
    9428: 2,
    9429: 1,
    9431: 5,
    9432: 7,
    9437: 3,
    9438: 1,
    9439: 1,
    9445: 1,
    9446: 0,
    9450: 0,
    9451: 0,
    9452: 1,
    9453: 1,
    9454: 0,
    9458: 0,
    9459: 0,
    9461: 0,
    9463: 1,
    9467: 0,
    9468: 1,
    9469: 1,
    9470: 1,
    9473: 1,
    9474: 1,
    9475: 1,
    9476: 1,
    9477: 1,
    9478: 0,
    9479: 1,
    9481: 0,
    9483: 0,
    9485: 1,
    9487: 1,
    9490: 0,
    9492: 2,
    9493: 0,
    9494: 7,
    9495: 2,
    9496: 2,
    9497: 1,
    9507: 1,
    9510: 1,
    9511: 1,
    9512: 0,
    9513: 0,
    9517: 1,
    9520: 1,
    9542: 2,
    9543: 2,
    9544: 2,
    9545: 2,
    9546: 0,
    9547: 0,
    9553: 2,
    9554: 2,
    9555: 1,
    9556: 7,
    9557: 3,
    9558: 2,
    9568: 0,
    9570: 0,
    9572: 0,
    9574: 1,
    9576: 1,
    9578: 0,
    9579: 1,
    9581: 4,
    9587: 0,
    9588: 0,
    9589: 0,
    9590: 0,
    9591: 0,
    9598: 0,
    9606: 1,
    9607: 0,
    9608: 0,
    9612: 2,
    9616: 3,
    9618: 1,
    9620: 4,
    9622: 1,
    9623: 1,
    9624: 1,
    9625: 1,
    9628: 3,
    9634: 2,
    9645: 0,
    9646: 1,
    9647: 0,
    9648: 0,
    9649: 1,
    9650: 0,
    9651: 0,
    9652: 0,
    9653: 0,
    9654: 0,
    9655: 0,
    9656: 0,
    9657: 0,
    9658: 0,
    9661: 0,
    9663: 0,
    9665: 0,
    9667: 1,
    9670: 1,
    9671: 1,
    9674: 1,
    9676: 1,
    9683: 2,
    9684: 3,
    9686: 2,
    9688: 3,
    9695: 0,
    9698: 1,
    9701: 0,
    9702: 0,
    9703: 0,
    9704: 0,
    9705: 0,
    9706: 1,
    9707: 1,
    9708: 0,
    9710: 13,
    9712: 0,
    9713: 1,
    9714: 0,
    9715: 13,
    9718: 0,
    9731: 0,
    9732: 0,
    9733: 0,
    9734: 0,
    9735: 0,
    9736: 2,
    9741: 0,
    9743: 1,
    9744: 0,
    9745: 0,
    9746: 0,
    9748: 1,
    9749: 0,
    9750: 1,
    9751: 1,
    9752: 0,
    9753: 0,
    9754: 0,
    9755: 0,
    9756: 3,
    9757: 0,
    9758: 0,
    9759: 0,
    9766: 2,
    9768: 2,
    9769: 3,
    9770: 3,
    9772: 1,
    9784: 3,
    9785: 0,
    9790: 0,
    9794: 1,
    9795: 1,
    9796: 0,
    9799: 0,
    9801: 0,
    9803: 0,
    9805: 0,
    9809: 0,
    9811: 3,
    9813: 0,
    9814: 0,
    9815: 0,
    30027: 0,
    30028: 0,
};
